import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
let TableStyleMap = (_class = class TableStyleMap {
  constructor(tableModel, styleTraits, key) {
    this.tableModel = tableModel;
    this.styleTraits = styleTraits;
    this.key = key;
    makeObservable(this);
  }

  /** Get traits for TableStyleMapSymbolTraits */
  get commonTraits() {
    return this.styleTraits[this.key];
  }

  /** Get all traits (this includes TableStyleMapTraits and specific SymbolTraits) */
  get traits() {
    return this.styleTraits[this.key];
  }

  /** Get all trait values for this TableStyleMapModel.
   * This is a JSON object
   */
  get traitValues() {
    return this.styleTraits.traits[this.key].toJson(this.traits);
  }
  get column() {
    return this.traitValues.column ? this.tableModel.tableColumns.find(column => column.name === this.traitValues.column) : undefined;
  }

  /**
   *
   */
  get styleMap() {
    // If column type is `scalar` and binStyles
    if ((this.traitValues.mapType === "bin" || !this.traitValues.mapType) && this.traitValues.bin && this.traitValues.bin.length > 0) {
      const mapValueToStyle = value => {
        var _this$traitValues$bin, _this$traitValues$bin2, _this$traitValues$bin3;
        if (typeof value !== "number") {
          return this.traitValues.null;
        }
        const binStyles = (_this$traitValues$bin = this.traitValues.bin) !== null && _this$traitValues$bin !== void 0 ? _this$traitValues$bin : [];
        let i;
        for (i = 0; i < binStyles.length - 1 && value > ((_binStyles$i$maxValue = binStyles[i].maxValue) !== null && _binStyles$i$maxValue !== void 0 ? _binStyles$i$maxValue : Infinity); ++i) {
          var _binStyles$i$maxValue;
          continue;
        }
        return _objectSpread(_objectSpread({}, this.traitValues.null), (_this$traitValues$bin2 = (_this$traitValues$bin3 = this.traitValues.bin) === null || _this$traitValues$bin3 === void 0 ? void 0 : _this$traitValues$bin3[i]) !== null && _this$traitValues$bin2 !== void 0 ? _this$traitValues$bin2 : {});
      };
      return {
        type: "bin",
        mapRowIdToStyle: rowId => {
          var _this$column;
          return mapValueToStyle((_this$column = this.column) === null || _this$column === void 0 ? void 0 : _this$column.valuesForType[rowId]);
        },
        mapValueToStyle
      };
    } else if ((this.traitValues.mapType === "enum" || !this.traitValues.mapType) && this.traitValues.enum && this.traitValues.enum.length > 0) {
      const mapValueToStyle = value => {
        const style = this.traitValues.enum.find(enumStyle => enumStyle.value !== null && enumStyle.value === value);
        return _objectSpread(_objectSpread({}, this.traitValues.null), style !== null && style !== void 0 ? style : {});
      };
      return {
        type: "enum",
        mapRowIdToStyle: rowId => {
          var _this$column2;
          return mapValueToStyle((_this$column2 = this.column) === null || _this$column2 === void 0 ? void 0 : _this$column2.values[rowId]);
        },
        mapValueToStyle
      };
    }

    // Return default settings
    return {
      type: "constant",
      style: this.traitValues.null
    };
  }
}, _applyDecoratedDescriptor(_class.prototype, "commonTraits", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "commonTraits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "traits", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "traits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "traitValues", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "traitValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "column", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "column"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "styleMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "styleMap"), _class.prototype), _class);
export { TableStyleMap as default };
export function isConstantStyleMap(map) {
  return map.type === "constant";
}